<template>
  <div>
    <div class="eod-modal-container eod-tab-container">
      <div class="header-container">
        <span>
          {{ `END OF DAY REPORT AS OF ${info.reportDate}` }}
        </span>
      </div>
      <div class="revenue-labour-container">
        <div class="wrapper">
          <div class="content">
            <div class="label">Target Revenue</div>
            <div class="separator"></div>
            <div class="value">{{ $box.formatMoney5(targetRevenue) }}</div>
          </div>
          <div class="content">
            <!-- {{ isSaveGenerate }} -->
            <div class="label">Actual Revenue</div>
            <div class="separator"></div>
            <div class="value">{{ $box.formatMoney5(actualRevenue) }}</div>
          </div>
          <div class="content" v-if="settings.compValue">
            <div class="label d-flex align-items-center">Comp Value</div>
            <div class="separator"></div>
            <div class="value p-5-all">
              <el-input type="number" v-model="compValue" class="comp peiso-input-default"></el-input>

            </div>
          </div>
          <div class="content total">
            <div class="label">Variance</div>
            <div class="separator"></div>
            <div class="value" :class="{ red: !revenueVariance.isGood }">{{ revenueVariance.total }}</div>
          </div>
        </div>

        <div class="wrapper">
          <div class="content">
            <div class="label">Target Labour</div>
            <div class="separator"></div>
            <div class="value">{{ $box.formatMoney5(targetLabour) }}</div>
          </div>
          <div class="content">
            <div class="label">Actual Labour</div>
            <div class="separator"></div>
            <div class="value">{{ $box.formatMoney5(actualLabour) }}</div>
          </div>
          <div class="content total">
            <div class="label">Variance</div>
            <div class="separator"></div>
            <div class="value" :class="{ 'red': !labourVariance.isGood }">{{ labourVariance.total }}</div>
          </div>
        </div>
      </div>

      <div>
        <template v-if="instance_type == 'main' || instance_type == 'sandbox'">
          <div class="revenue-labour-container">
            <div class="wrapper">
              <div class="content" v-if="settings.accommodationRevenue">
                <div class="label d-flex align-items-center">{{ settings.accommodationRevenueLabel ? settings.accommodationRevenueLabel : 'Accommodation Revenue' }}</div>
                <div class="separator"></div>
                <div class="value p-5-all">
                  <!-- <el-input type="number" v-model="compValue" class="comp peiso-input-default"></el-input> -->
                  <input-number v-model="accomRevenue" @change="saveEodChange"
                    :class="{ 'is-error': !$box.checkValueExists(accomRevenue) }"
                    class="comp peiso-numerical h-40 right-align b-right-bottom" :ref="`accommodationRate`" :value="0"
                    :empty-value="''" :precision="2"></input-number>

                </div>
              </div>
            </div>

            <div class="wrapper">
              <div class="content" v-if="settings.accommodationRate">
                <div class="label d-flex align-items-center">{{ settings.accommodationRateLabel ? settings.accommodationRateLabel : 'Accommodation Rate' }}</div>
                <div class="separator"></div>
                <div class="value p-5-all">
                  <!-- <el-input type="number" v-model="compValue" class="comp peiso-input-default"></el-input> -->
                  <input-number v-model="accomRate" @change="saveEodChange"
                    :class="{ 'is-error': !$box.checkValueExists(accomRate) }"
                    class="comp peiso-numerical h-40 right-align b-right-bottom" :ref="`accommodationRate`" :value="0"
                    :empty-value="''" :precision="2"></input-number>

                </div>
              </div>
            </div>
          </div>
        </template>

        <template>
          <div class="revenue-labour-container">
            <div class="wrapper">
              <div class="content" v-if="settings.usedRoomsCountToggle">
                <div class="label d-flex align-items-center">{{ settings.usedRoomsCountLabel ? settings.usedRoomsCountLabel  : 'Room Used' }}</div>
                <div class="separator"></div>
                <div class="value p-5-all">
                  <!-- <el-input type="number" v-model="compValue" class="comp peiso-input-default"></el-input> -->
                  <el-input type="" v-model="roomUsed" @change="saveEodChange"
                    :class="{ 'is-error': !$box.checkValueExists(roomUsed) }"
                    class="comp peiso-input-default" :ref="`roomUsed`" :value="0"></el-input>

                </div>
              </div>
            </div>
            <div class="wrapper">
              <div class="content" v-if="settings.availableRoomsCountToggle">
                <div class="label d-flex align-items-center">{{ settings.availableRoomsCountLabel ? settings.availableRoomsCountLabel  : 'Room Available' }}</div>
                <div class="separator"></div>
                <div class="value p-5-all">
                  <!-- <el-input type="number" v-model="compValue" class="comp peiso-input-default"></el-input> -->
                  <el-input type="" v-model="availableRoomsCount" @change="saveEodChange"
                    :class="{ 'is-error': !$box.checkValueExists(availableRoomsCount) }"
                    class="comp peiso-input-default" :ref="`availableRoomsCount`" :value="0"></el-input>

                </div>
              </div>
            </div>
          </div>
          
        </template>


        <template>
          <div class="revenue-labour-container">
            <div class="wrapper">
              <div class="content" v-if="settings.purchases">
                <div class="label d-flex align-items-center">{{ settings.purchasesLabel  }}</div>
                <div class="separator"></div>
                <div class="value p-5-all d-flex gap-10">
                  <!-- <el-input type="number" v-model="compValue" class="comp peiso-input-default"></el-input> -->
                  <input-number v-model="purchases" @change="saveEodChange" @input="inputToGetPurchasesTotal"
                    :class="{ 'is-error': !$box.checkValueExists(purchases) }"
                    class="comp peiso-numerical h-40 right-align b-right-bottom" :ref="`purchases`" :value="0"
                    :empty-value="''" :precision="2"></input-number>
                  <el-input type="text" v-model="purchasesPercentage" class="peiso-input-default w-auto h-50 w-80 eod-size-16 center-align" readonly></el-input>
                </div>
              </div>
            </div>

            <div class="wrapper">
              <div class="content" v-if="settings.weekToDate">
                <div class="label d-flex align-items-center">{{ settings.weekToDateLabel }}</div>
                <div class="separator"></div>
                <div class="value p-5-all d-flex gap-10">
                  <!-- <el-input type="number" v-model="compValue" class="comp peiso-input-default"></el-input> -->
                  <input-number v-model="weekToDate" @change="saveEodChange" readonly
                    :class="{ 'is-error': !$box.checkValueExists(weekToDate) }"
                    class="comp peiso-numerical h-40 right-align b-right-bottom" :ref="`weekToDate`" :value="0"
                    :empty-value="''" :precision="2"></input-number>
                  <el-input type="text" v-model="weekToDatePercentage" class="peiso-input-default w-auto h-50 w-80 eod-size-16 center-align" readonly></el-input>
                </div>
              </div>
            </div>
          </div>
        </template>

      </div>

      <template v-if="info.periodicData && info.periodicData.length">

        <div class="header subheaders">
          <span>
            PERIODIC REPORT HISTORY
          </span>

          <span class="d-none">{{ actualRosteredCapture }}</span>
        </div>
        <div class="revenue-labour-container">
          <div class="wrapper">
            <div class="content">
              <div class="label"></div>
              <div class="separator"></div>
              <div class="value text-center">Actual Revenue</div>
              <div class="separator"></div>
              <div class="value text-center">Actual Roster</div>
              <div class="separator"></div>
              <div class="value text-center">Labour Cost (%)</div>
              <div class="separator"></div>
              <div class="value text-center">Weather Report</div>
              <!-- <div class="separator"></div>
              <div class="value text-center">Cover</div>
              <div class="separator"></div>
              <div class="value text-center">SPH</div> -->
            </div>

            <div class="content" v-for="(item, i) in info.periodicData" :key="`periodicData-${i}`">
              <div class="label">{{ `${item.periodicName} (${item.reportTime})` }}</div>
              <div class="separator"></div>
              <div class="value text-center">{{ $box.formatMoney5(item.actualRevenue) }}</div>
              <div class="separator"></div>
              <div class="value text-center">{{ $box.formatMoney5(item.actualRoster) }}</div>
              <div class="separator"></div>
              <div class="value text-center">{{ item.labourCost }}</div>
              <div class="separator"></div>
              <div class="value text-center text-capitalize">{{ `${item.weatherPOJO.temperature}°C` }} <br> {{
                item.weatherPOJO.description }}</div>
              <!-- <div class="separator"></div>
              <div class="value text-center">
                <input class="cover-input" type="number" v-model="item.cover" @input="onChangePeriodicCover(i, $event)">
              </div>
              <div class="separator"></div>
              <div class="value text-center">{{item.sph}}</div> -->
            </div>
          </div>
        </div>
      </template>

      <div class="header subheaders" v-if="employeeVariance.length && !isDisableStaffVariance">
        <span>
          STAFF WORKING WITH VARIANCE
        </span>
      </div>
      <div class="revenue-labour-container" v-if="employeeVariance.length && !isDisableStaffVariance">
        <div class="wrapper">
          <div class="content" v-for="(item, i) in employeeVariance" :key="`employee${i}`">
            <div class="label">{{ item.employee }}</div>
            <div class="separator"></div>
            <div class="value red">{{ item.varianceString }}</div>
          </div>
          <div class="content total">
            <div class="label">Total Variance</div>
            <div class="separator"></div>
            <div class="value red">{{ totalVariance }}</div>
          </div>
        </div>
      </div>

      <div class="input-container">
        <span>Manager on Duty</span>
        <el-input v-model="manager" @change="saveEodChange" :class="{ 'is-error': manager == '' }"
          placeholder="Name of the manager" class="peiso-input-default"></el-input>
      </div>

      <div class="input-container">
        <div class="cash-relate-container">
          <div class="input">
            <span>Labour Cost</span>
            <el-input type="text" v-model="labourCostTotal" class="peiso-input-default" :readonly="true"></el-input>
          </div>
          <div class="input">
            <span>Food</span>
            <el-input type="number" @change="saveEodChange" :class="{ 'is-error': !parseFloat(food) }" v-model="food"
              class="peiso-input-default"></el-input>
          </div>
          <div class="input">
            <span>Beverage</span>
            <el-input type="number" @change="saveEodChange" :class="{ 'is-error': !parseFloat(beverage) }"
              v-model="beverage" class="peiso-input-default"></el-input>
          </div>

          <div class="input">
            <span>Cover</span>
            <el-input type="number" id="cover" @change="saveEodChange" :readonly="!settings.isEditCover ? true : false" v-model="cover" @input="spentPerHead"
              class="peiso-input-default"></el-input>
          </div>

          <div class="input">
            <span>SPH</span>
            <el-input v-model="sph" class="peiso-input-default" :readonly="true"></el-input>
          </div>
        </div>
      </div>

      <div class="header subheaders">
        <span>
          REPORT NOTES
        </span>

        <!-- <span class="d-block notes">
          (Leave as blank on the field you don't want to put a notes.)
        </span> -->
      </div>

      <div class="input-container">
        <div class="cash-relate-container flex-column">
          <div class="input left-align" v-if="settings.managerService">
            <span>{{ `${settings.managerServiceLabel}:` }}</span>
            <!-- <textarea v-model="manageServiceNote" @change="saveEodChange"></textarea> -->
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" :maxlength="textLength"
              v-model="manageServiceNote" @change="saveEodChange" class="peiso-input-default"></el-input>
            <div class="text-indicator d-flex justify-content-end">{{ `${manageServiceNote.length}/${textLength}` }}</div>
          </div>

          <template>
            <div class="input left-align" v-if="settings.labourWeekToDate">
              <span>{{ settings.labourWeekToDateLabel }}</span>
              <!-- <textarea v-model="manageServiceNote" @change="saveEodChange"></textarea> -->
              <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" :maxlength="textLength"
                v-model="labourWeekToDate" @change="saveEodChange" class="peiso-input-default"></el-input>
              <div class="text-indicator d-flex justify-content-end">{{ `${labourWeekToDate.length}/${textLength}` }}</div>
            </div>
          </template>

          <div class="input left-align" v-if="settings.bevService">
            <span>{{ `${settings.bevServiceLabel}:` }}</span>
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" :maxlength="textLength"
              v-model="bevServiceNote" @change="saveEodChange" class="peiso-input-default"></el-input>
            <div class="text-indicator d-flex justify-content-end">{{ `${bevServiceNote.length}/${textLength}` }}</div>

          </div>
        </div>
      </div>

      <div class="input-container">
        <div class="cash-relate-container flex-column">
          <div class="input left-align" v-if="settings.venueVibe">
            <span>{{ `${settings.venueVibeLabel}:` }}</span>
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" :maxlength="textLength"
              v-model="venueVibe" @change="saveEodChange" class="peiso-input-default"></el-input>
            <div class="text-indicator d-flex justify-content-end">{{ `${venueVibe.length}/${textLength}` }}</div>
          </div>
          <div class="input left-align" v-if="settings.weatherRecords">
            <span>{{ `${settings.weatherRecordsLabel}:` }}</span>
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" :maxlength="textLength"
              v-model="weatherRecord" @change="saveEodChange" class="peiso-input-default weather"></el-input>
            <div class="text-indicator d-flex justify-content-end">{{ `${weatherRecord.length}/${textLength}` }}</div>
          </div>
        </div>
      </div>


      <div class="input-container">
        <div class="cash-relate-container flex-column">
          <div class="input left-align" v-if="settings.largeParties">
            <span>{{ `${settings.largePartiesLabel}:` }}</span>
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" :maxlength="textLength"
              v-model="largeParties" @change="saveEodChange" class="peiso-input-default"></el-input>
            <div class="text-indicator d-flex justify-content-end">{{ `${largeParties.length}/${textLength}` }}</div>
          </div>
          <div class="input left-align" v-if="settings.vip">
            <span>{{ `${settings.vipLabel}:` }}</span>
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" :maxlength="textLength" v-model="vip"
              @change="saveEodChange" class="peiso-input-default"></el-input>
            <div class="text-indicator d-flex justify-content-end">{{ `${vip.length}/${textLength}` }}</div>
          </div>
        </div>
      </div>

      <div class="input-container" v-if="settings.managerService">
        <div class="cash-relate-container flex-column">
          <div class="input left-align" v-if="settings.staff">
            <span>{{ `${settings.staffLabel}:` }}</span>
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" :maxlength="textLength" v-model="staff"
              @change="saveEodChange" class="peiso-input-default"></el-input>
            <div class="text-indicator d-flex justify-content-end">{{ `${staff.length}/${textLength}`}}</div>
          </div>
          <div class="input left-align" v-if="settings.training">
            <span>{{ `${settings.trainingLabel}:` }}</span>
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" :maxlength="textLength" v-model="training"
              @change="saveEodChange" class="peiso-input-default"></el-input>
            <div class="text-indicator d-flex justify-content-end">{{ `${training.length}/${textLength}` }}</div>
          </div>
        </div>
      </div>

      <div class="input-container">
        <div class="cash-relate-container flex-column">
          <div class="input left-align" v-if="settings.compExp">
            <span>{{ `${settings.compExpLabel}:` }}</span>
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" :maxlength="textLength" v-model="compExp"
              @change="saveEodChange" class="peiso-input-default"></el-input>
            <div class="text-indicator d-flex justify-content-end">{{ `${compExp.length}/${textLength}`}}</div>
          </div>
          <div class="input left-align" v-if="settings.whs">
            <span>{{ `${settings.whsLabel}:` }}</span>
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" :maxlength="textLength" v-model="whs"
              @change="saveEodChange" class="peiso-input-default"></el-input>
            <div class="text-indicator d-flex justify-content-end">{{ `${whs.length}/${textLength}` }}</div>
          </div>
        </div>
      </div>


      <div class="input-container">
        <div class="cash-relate-container flex-column">
          <div class="input left-align" v-if="settings.repairs">
            <span>{{ `${settings.repairsLabel}:` }}</span>
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" :maxlength="textLength" v-model="repairs"
              @change="saveEodChange" class="peiso-input-default"></el-input>
            <div class="text-indicator d-flex justify-content-end">{{ `${repairs.length}/${textLength}`}}</div>
          </div>
          <div class="input left-align" v-if="settings.others">
            <span>{{ `${settings.othersLabel}:` }}</span>
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" :maxlength="textLength"
              v-model="otherFeedback" @change="saveEodChange" class="peiso-input-default"></el-input>
            <div class="text-indicator d-flex justify-content-end">{{ `${otherFeedback.length}/${textLength}` }}</div>
          </div>
        </div>
      </div>

      <div class="input-container">
        <div class="cash-relate-container flex-column">
          <div class="input left-align" v-if="settings.execSummary">
            <span>{{ `${settings.execSummaryLabel}:` }}</span>
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" :maxlength="textLength" v-model="execSummary"
              @change="saveEodChange" class="peiso-input-default"></el-input>
            <div class="text-indicator d-flex justify-content-end">{{ `${execSummary.length}/${textLength}`}}</div>
          </div>
        </div>
      </div>

      <div class="input-container" v-if="settings.uploadImage">
        <div class="cash-relate-container">
          <div class="input left-align">
            <span>Upload Image: </span>
            <div class="upload-con">
              <i class="icon" v-if="!uploading"></i>
              <h3 v-if="!uploading" class="text"> Drag the file here, or <small>Click to upload</small><br />You can
                upload
                more than one file.</h3>

              <div class="demo">
                <el-upload v-if="!uploading" :file-list="fileList" :auto-upload="false" :show-file-list="true"
                  class="upload-demo" drag :multiple="true" action="#" :on-change="handleChange"
                  :on-remove="handleRemove">
                </el-upload>

              </div>
              <i class="el-icon-loading" v-if="uploading"></i>
            </div>


          </div>

        </div>
      </div>

    </div>

    <!-- <div class="button-container w-100 d-flex justify-content-center">
            <el-button v-if="!isLoading" type="peiso-border-button" @click="getCurrentLabour()">Save and Generate Report</el-button>
            <el-button v-if="isLoading" type="peiso-border-button" class="cursor-disable" :disabled="isEodEnable">Generating report...</el-button>

        </div> -->
  </div>
</template>
<style lang="scss">
.eod-tab-container {
  overflow: inherit !important;
}
</style>
<script>
import api from '@/api/dashboard'
import Utils from '../../utils/utils'
import inputNumber from '@/components/input/inputNumber.vue';
import { INSTANCE_TYPE } from '../../../config.env';
import utils from '../../utils/utils';

export default {
  data() {
    return {
      uploading: false,
      fileList: [],
      fileListUrl: [],
      file: null,
      uploadUrl: '',

      visible: false,
      manager: '',
      food: '',
      beverage: '',
      cover: '',
      sph: '',
      labourCost: '',
      compValue: '',
      accomRevenue: '',
      accomRate: '',
      manageServiceNote: '',
      bevServiceNote: '',
      venueVibe: '',
      weatherRecord: '',
      largeParties: '',
      vip: '',
      staff: '',
      training: '',
      compExp: '',
      whs: '',
      repairs: '',
      otherFeedback: '',
      labourWeekToDate: '',
      execSummary: '',
      instance_type: process.env.INSTANCE_TYPE,
      isDisableStaffVariance: true,
      textLength: 3000,
      isLoading: false,
      roomUsed: 0,
      availableRoomsCount: 0,
      purchases: '',
      purchasesPercentage: '',
      weekToDate: '',
      weekToDatePercentage: ''
      // eodHistory: null,
    }
  },
  props: {
    show: {
      default: false
    },
    type: {
      default: false
    },
    info: {
      default: null
    },
    employeeVariance: {
      default: []
    },
    actual: {
      default: 0
    },
    eodHistory: {
      default: null
    },
    targetLabourData: {
      default: null,
    },
    weeklyData: {
      default: null,
    },
    weeklyDay: {
      default: null,
    },
    weeklyFullTimeCost: {
      default: null,
    },
    actualLabourCost: {
      default: 0,
    },
    total: {
      default: ''
    },
    isSaveGenerate: {
      default: false
    },
    actualRosteredCapture: {
      default: null
    },
    settings: {
      default: {}
    },
    isCurrentDay: {
        default: 0
    },
    calculatedRevenue: {
      default: 0
    }
  },
  watch: {
    show(val) {
      this.visible = val
    },

    visible(val) {
      if (!val) {
        this.$emit('closeDialog')
      }
      // this.labourCost = this.labourCostTotal()
    },

    async eodHistory(data) {
      this.getWeather()
      if (data) {

        var blob = new Blob([data.pdf_content], { type: 'application/pdf' })
        var url = URL.createObjectURL(blob)
        this.compValue = !data.compValue ? '' : data.compValue
        this.manager = data.name_manager_duty ? data.name_manager_duty : ''

        this.manageServiceNote = data.manageServiceNote ? data.manageServiceNote : ''
        this.bevServiceNote = data.bevServiceNote ? data.bevServiceNote : ''
        this.venueVibe = data.venueVibe ? data.venueVibe : ''

        this.largeParties = data.largeParties ? data.largeParties : ''
        this.vip = data.vip ? data.vip : ''
        this.staff = data.staff ? data.staff : ''
        this.training = data.training ? data.training : ''
        this.compExp = data.compExp ? data.compExp : ''
        this.whs = data.whs ? data.whs : ''
        this.repairs = data.repairs ? data.repairs : ''
        this.execSummary = data.execSummary ? data.execSummary : ''
        this.otherFeedback = data.otherFeedback ? data.otherFeedback : ''
        this.accomRate = data.accommodation_rate ? data.accommodation_rate : ''
        this.accomRevenue = data.accommodation_revenue ? data.accommodation_revenue : ''
        this.purchases = data.purchases ? data.purchases : ''
        this.weekToDate = data.weekToDate ? data.weekToDate : ''
        this.weekToDatePercentage = Utils.percentageTotal(this.weekToDate, this.calculatedRevenue)
        this.purchasesPercentage = Utils.percentageTotal(this.purchases, this.eodHistory.actualRevenue)
        this.roomUsed = data.usedRoomsCount ? data.usedRoomsCount : 0
        this.availableRoomsCount = data.availableRoomsCount ? data.availableRoomsCount : 0

        let dataCover = parseFloat(data.cover) ? parseFloat(data.cover) : 0
        let totalCover = parseFloat(this.cover) ? parseFloat(this.cover) : 0
        let food = parseFloat(data.food) ? parseFloat(data.food) : 0
        let beverage = parseFloat(data.beverage) ? parseFloat(data.beverage) : 0

        if (!this.settings.isEditCover && data.type == 'dinner') {
          this.cover = totalCover
        } else {
          if (dataCover) {
            this.cover = dataCover
          } else {
            this.cover = totalCover
          }
        }

        this.spentPerHead(this.cover);

        if (food) {
          this.food = food
        }
        if (beverage) {
          this.beverage = beverage
        }

        this.labourWeekToDate = data.labourWeekToDate ? data.labourWeekToDate : '';


        // if (data.document) {
        //     const formatType = this.checkFileFormat(data.document);
        //     this.uploadUrl = `data:image/${formatType};base64,${data.document}`;

        //     this.file = await this.urltoFile(this.uploadUrl, 'upload-image.png', 'image/png');
        // }


        if (data.fileList && data.fileList.length > 0) {
          for (let i = 0; i < data.fileList.length; i++) {
            const fileData = data.fileList[i];

            this.fileList.push({
              name: fileData.fileName,
              url: fileData.filePath,
              raw: await this.urlToFile(fileData.filePath, fileData.fileName, fileData.fileType)
            });


          }
          // const formatType = this.checkFileFormat(data.document);
          // this.uploadUrl = `data:image/${formatType};base64,${data.document}`;

          // this.file = await this.urltoFile(this.uploadUrl, 'upload-image.png', 'image/png');
        }
      }
    },

    total(val) {
      if (val) {
        console.log('val: ', val);
        this.cover = val.totalCover
        this.food = val.totalFood
        this.beverage = val.totalBeverage

        this.spentPerHead(this.cover)
      }
    },

    isSaveGenerate(val) {
      if (val) {
        this.getPayloads(1)
        this.isLoading = false
      }
    },

    actual() {
      this.spentPerHead(this.cover);
    },
    cover() {
      this.spentPerHead(this.cover);
    },

    calculatedRevenue(val) {
      if (val) {
        this.weekToDatePercentage = Utils.percentageTotal(this.weekToDate, val)
      }
    }

  },
  computed: {
    isEodEnable() {
      if (this.manager == '') {
        return true
      }

      if (!parseFloat(this.food)) {
        return true
      }

      if (!parseFloat(this.beverage)) {
        return true
      }

      // if (!parseFloat(this.cover)) {
      //     return true
      // }

      return false
    },
    actualRevenue() {
      if (this.eodHistory && this.eodHistory.isSent && this.type == 'lunch') {
        return utils.safeValue(this.eodHistory.actualRevenue)
      }

      return utils.safeValue(this.actual)
    },

    targetRevenue() {
      if (this.eodHistory && this.eodHistory.isSent && this.type == 'lunch') {
        return utils.safeValue(this.eodHistory.targetRevenue)
      }


      return utils.safeValue(this.info.revenueTarget)
    },

    actualLabour() {
      return utils.safeValue(this.info.actualRoster)
    },

    targetLabour() {

      if (this.eodHistory && this.eodHistory.isSent && this.type == 'lunch') {
        return this.eodHistory.targetLabour
      }

      return this.info.targetRoster ? this.info.targetRoster : 0
    },

    revenueVariance() {

      var total = ''
      var variance = 0
      if (this.compValue != '') {
        variance = this.actualRevenue - this.targetRevenue - this.compValue
      } else {
        variance = this.actualRevenue - this.targetRevenue
      }

      if (variance < 0) {
        total = `${this.$box.formatMoney5(variance)}`
      } else if (variance > 0) {
        total = `+${this.$box.formatMoney5(variance)}`
      } else {
        total = this.$box.formatMoney5(variance)
      }

      return {
        total: total,
        isGood: variance >= 0 ? 1 : 0
      }
    },
    labourVariance() {
      var variance = this.actualLabour - this.targetLabour
      var total = ''
      if (variance < 0) {
        total = `${this.$box.formatMoney5(variance)}`
      } else if (variance > 0) {
        total = `+${this.$box.formatMoney5(variance)}`
      } else {
        total = this.$box.formatMoney5(variance)
      }

      return {
        total: total,
        isGood: variance <= 0 ? 1 : 0
      }
    },
    totalVariance() {
      var totalVariance = 0

      this.employeeVariance.forEach(n => {
        totalVariance += parseFloat(n.variance)
      });

      return `${totalVariance}h`
    },

    labourCostTotal() {
      var rev = this.actualRevenue
      var lab = this.actualLabour
      if (!rev) {
        return `100%`
      } else if (!lab) {
        return `${0}%`
      }

      var labourCost = lab / rev
      labourCost = labourCost * 100


      return `${labourCost.toFixed(2)}%`
    },

  },
  methods: {
    handleRemove(file, fileList) {
      this.fileList = fileList;
      this.saveEodChange();
    },
    handlePreview() {

    },

    async urlToFile(url, filename, mimeType) {
      // 'https://cors-anywhere.herokuapp.com/'
      const response = await fetch('https://corsproxy.io/?' + url);
      const data = await response.blob();
      console.log('blobData: ', data);
      return new File([data], filename, { type: mimeType });
    },

    checkFileFormat(base64String) {
      // Decode the Base64 string
      console.log('base64String: ', base64String);
      const binaryString = atob(base64String);

      // Get the first few bytes (header) to determine the file format
      const header = binaryString.substring(0, 16);
      // Check for common file format signatures
      if (header.startsWith('\x89\x50\x4E\x47')) {
        return 'png'; // PNG file
      } else if (header.startsWith('\xFF\xD8\xFF')) {
        return 'jpeg'; // JPEG file
      } else if (header.startsWith('BM')) {
        return 'bmp'; // BMP file
      } else if (header.startsWith('GIF')) {
        return 'gif'; // GIF file
      } else if (header.startsWith('<svg')) {
        return 'svg+xml'; // SVG file
      } else {
        return 'jpeg'; // Unknown file format
      }
    },

    async urltoFile(url, filename, mimeType) {
      if (url.startsWith('data:')) {
        var arr = url.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[arr.length - 1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        var file = new File([u8arr], filename, { type: mime || mimeType });
        return Promise.resolve(file);
      }
      return fetch(url)
        .then(res => res.arrayBuffer())
        .then(buf => new File([buf], filename, { type: mimeType }));
    },

    async handleChange(file, fileList) {
      console.log({ fileList });
      const isLt3M = file.size / 1024 / 1024 < 3; // Changed from 2 to 3

      if (!isLt3M) {
        Utils.alert2('', 'Image size cannot exceed 3MB!', 'error'); // Adjusted error message
      } else {
        this.file = file.raw;
        this.uploadUrl = URL.createObjectURL(file.raw);
        this.fileList = fileList;
        this.fileListUrl.push(this.uploadUrl);

        clearTimeout(this.timer);
        this.timer = setTimeout(this.handleUploadFile, 2000);
      }
    },

    handleUploadFile() {
      this.saveEodChange();
    },

    spentPerHead(e) {
      if (!parseFloat(e)) {
        this.sph = 0
        return 0
      }
      var total = this.actualRevenue / e
      this.sph = total.toFixed(2)

      console.log(this.sph, 'this.sph')
    },

    getPayloads(type) {

      var payload = {}

      payload.revenue = {
        target: this.$box.formatMoney5(this.targetRevenue),
        actual: this.$box.formatMoney5(this.actualRevenue),
        variance: this.revenueVariance.total,
        isGood: this.revenueVariance.isGood
      },

        payload.labour = {
          target: this.$box.formatMoney5(this.targetLabour),
          actual: this.$box.formatMoney5(this.actualLabour),
          variance: this.labourVariance.total,
          isGood: this.labourVariance.isGood
        }

      payload.staffVariance = this.employeeVariance
      payload.totalStaffVariance = this.totalVariance
      payload.venueName = sessionStorage.getItem("subVenueName")
      // payload.reportDate = Utils.dateTimeGenerator(new Date()).toUpperCase()
      payload.reportDate = Utils.dateTimeGenerator(sessionStorage.getItem('currentBusinessDay')).toUpperCase()
      payload.reportDateFormatted = this.info.reportDateFormatted
      payload.manager = this.manager
      payload.labourCost = this.labourCostTotal
      payload.food = this.food
      payload.beverage = this.beverage
      payload.cover = this.cover
      payload.sph = this.sph

      payload.periodicData = this.info.periodicData
      payload.manageServiceNote = this.manageServiceNote
      payload.bevServiceNote = this.bevServiceNote
      payload.venueVibe = this.venueVibe
      payload.weatherRecord = this.weatherRecord
      payload.largeParties = this.largeParties
      payload.vip = this.vip
      payload.staff = this.staff
      payload.training = this.training
      payload.compExp = this.compExp
      payload.whs = this.whs
      payload.repairs = this.repairs
      payload.otherFeedback = this.otherFeedback
      payload.compValue = !parseFloat(this.compValue) ? '' : this.compValue
      payload.isGenerate = type == 1 ? true : false,
      payload.accommodationRate = this.accomRate
      payload.accommodationRevenue = this.accomRevenue
      payload.fileList = this.fileList;
      payload.type = this.type;
      payload.labourWeekToDate = this.labourWeekToDate;
      payload.execSummary = this.execSummary,
      payload.weekToDate = this.weekToDate ? this.weekToDate : ''
      payload.purchases = this.purchases ? this.purchases : ''
      payload.usedRoomsCount = this.roomUsed ? this.roomUsed : ''
      payload.availableRoomsCount = this.availableRoomsCount ? this.availableRoomsCount : ''
      this.$emit('generate-report', payload, type)

    },


    clearFields() {
      this.manager = ''
      this.sph = ''
      this.labourCost = ''
      this.compValue = ''
      this.manageServiceNote = ''
      this.bevServiceNote = ''
      this.venueVibe = ''
      this.weatherRecord = ''
      this.largeParties = ''
      this.vip = ''
      this.staff = ''
      this.training = ''
      this.compExp = ''
      this.whs = ''
      this.repairs = ''
      this.otherFeedback = ''
      this.file = null
      this.uploadUrl = ''
      this.purchases = ''
      this.purchasesPercentage = ''
      this.weekToDate = ''
      this.weekToDatePercentage = ''
    },
    saveEodChange(e) {
      this.getPayloads(2)
    },

    getCurrentLabour() {
      // if (this.manager == '') {
      //     Utils.alert2('', 'Please input manager on duty field.', 'error')
      //     return true
      // }

      // if (!parseFloat(this.food)) {
      //     Utils.alert2('', 'Please input food total field.', 'error')
      //     return true
      // }

      // if (!parseFloat(this.beverage)) {
      //     Utils.alert2('', 'Please input beverage total field.', 'error')
      //     return true
      // }

      this.isLoading = true
      this.$emit('refresh-eod')
    },

    setTotalFoodBeverage() {
      var val = this.total
      if (val) {
        this.cover = val.totalCover
        this.food = val.totalFood
        this.beverage = val.totalBeverage

        this.spentPerHead(this.cover)
      }
    },


    getWeather() {

      const weatherStatus = sessionStorage.getItem('weather-status');

      if (weatherStatus && weatherStatus != 'undefined') {
        const weather = JSON.parse(weatherStatus)
        var desc = weather.description

        this.weatherRecord = `${weather.temperature}°C - ${desc}`
      }
    },
    
    inputToGetPurchasesTotal(total) {
      const revenue = this.actualRevenue ? this.actualRevenue : 0
      this.purchasesPercentage = Utils.percentageTotal(total, revenue)
    },

  },
  mounted() {
    this.setTotalFoodBeverage()
    this.getWeather()
  },

  components: {
    inputNumber: inputNumber,
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/eodForm.vue